// components/NoDataFound.jsx
import React from 'react';
import nodataGif from '../../../../../images/recordNotFound.gif'; // Adjust the path based on your folder structure

const NoDataFound = ({ height = {} }) => {
  return (
    <div
      style={{ height }}
      className="d-flex justify-content-center align-items-center"
    >
      {/*<img src={nodataGif} alt="No data found" />*/}
     <div>
        <p
        className='no-data-found'
          // style={{
          //   fontSize: '1.25rem',
          //   color: '#6c757d',
          //   margin: 0,
          // }}
        >
          No data found
        </p>
      </div>
    </div>
  );
};

export default NoDataFound;
